import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material
import { Box, Button, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { UserTable } from "../components/_dashboard/app";
import { clearUserProfile } from "../core/redux/action/userProfile";
import StdUsersTable from "../components/_dashboard/app/userTable/StdUsersTable";
import { getMentorsRelationStd } from "../core/service/mentor.service";
import { getGranteesAdmin } from "../core/service/grantees.service";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function Member() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const [relationStd, setRelationStd] = useState([]);
  const [user, setUser] = useState({});
  const [grantees, setGrantees] = useState([]);

  const getMentorsRelation = async () => {
    const data = await getMentorsRelationStd();
    setRelationStd(data);
  };

  const getMentorGranteesAdmin = async () => {
    const data = await getGranteesAdmin();
    setGrantees(data.entities);
  };

  useEffect(() => {
    dispatch(clearUserProfile());
    getMentorsRelation();
    getMentorGranteesAdmin();
  }, []);

  return (
    <Page title="Member">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={12}>
            <UserTable ListUsers={relationStd} currentUserRole={role} />
          </Grid>

          <Grid item xs={12} md={6} lg={12} sx={{ marginTop: 5 }}>
            <StdUsersTable ListUsers={grantees || []} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
